// src/pages/admin/agenda/CalendarioReunionesPage.tsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import CalendarioReuniones from '../../../components/CalendarioReuniones/CalendarioReuniones';

const CalendarioReunionesPage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
        Calendario de Reuniones
      </Typography>
      <CalendarioReuniones />
    </Box>
  );
};

export default CalendarioReunionesPage;
